import React from 'react'
import PropTypes from 'prop-types'
import { RenderNav, SignupFooter } from '../auth/SignupFlow'
import { ThemeProvider } from 'styled-components'

import { buildTheme, buildGlobalStyle, buildHead } from '/styles/theme'

const SignupLayout = ({ siteData, children }) => {
  const theme = buildTheme(siteData)
  const GlobalStyle = buildGlobalStyle(siteData)
  const head = buildHead(siteData)

  return (
    <ThemeProvider theme={theme}>
      {head}
      <GlobalStyle />
      <div className="signup-page">
        <section>
          <RenderNav />
          <div key="content" className="pricing-wrapper">
            <div className="pricing-block">
              <div className="background"></div>
              <div className="content">
                <div className="content-wrapper">{children}</div>
              </div>
            </div>
          </div>
          <SignupFooter />
        </section>
      </div>
    </ThemeProvider>
  )
}

SignupLayout.proptypes = {
  children: PropTypes.object
}

export default SignupLayout
